<!--Vista para cambiar contraseña
    El usuario obtiene el acceso a esta url mediante un correo que le llega al momento
    de ingresar su correo en la sección de recuperación de contraseña.
-->
<template>
  <v-container fluid class="loginContainer primary">
    <v-row justify="center" align="center" class="loginWrapper">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="11" sm="7" md="5" lg="4" xl="3">
            <v-card class="px-8 pt-10">
              <v-form v-on:submit.prevent="validate" ref="form" v-model="valid" lazy-validation>
                <v-row justify="center">
                  <v-col cols="12" class="text-center">
                    <h1 class="display-1 font-weight-bold">Nueva contraseña</h1>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="user.password"
                      prepend-icon="fas fa-lock"
                      :append-icon="showPass ? 'visibility' : 'visibility_off'"
                      :rules="passwordRules"
                      :type="showPass ? 'text' : 'password'"
                      name="password"
                      label="Contraseña"
                      hint="Debe incluir al menos 8 caracteres."
                      counter
                      @click:append="showPass = !showPass"
                    ></v-text-field>
                    <v-text-field
                      v-model.trim="user.passwordConfirmation"
                      prepend-icon="fas fa-lock"
                      :append-icon="showPass ? 'visibility' : 'visibility_off'"
                      :rules="[validatePasswords]"
                      :type="showPass ? 'text' : 'password'"
                      name="password"
                      label="Contraseña"
                      counter
                      @click:append="showPass = !showPass"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="center" class="mb-3">
                      <v-btn
                        :loading="loading"
                        type="submit"
                        :disabled="!valid"
                        color="accent"
                        block
                        large
                        class="black--text font-weight-bold"
                      >Guardar</v-btn>
                    </v-row>
                    <v-row justify="center" class="text-center">
                      <v-col cols="11" md="10" xl="9">
                        <p class="subtitle-1">
                          ¿Ya tienes una cuenta?
                          <span
                            class="secondary--text font-weight-bold pointer"
                            @click="login()"
                          >Inicia sesión.</span>
                        </p>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-form>
            </v-card>
          </v-col>
        </v-row>
        <v-row justify="center" align="center" class="mt-10">
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
          <v-col cols="6" sm="4" md="3" lg="3" xl="2">
            <v-row justify="center">
              <v-img src="@/assets/logo-WC.png" width="100%" height="auto"></v-img>
            </v-row>
          </v-col>
          <v-col cols="2" sm="3" md="3" lg="4" xl="3">
            <v-divider color="white"></v-divider>
          </v-col>
        </v-row>
      </v-col>
      <v-dialog v-model="dialog" max-width="400" persistent>
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="black--text pb-0">
                  <span class="headline font-weight-bold">Error</span>
                  <p
                    class="text-justify"
                  >Una vez solicitado el cambio de contraseña se tiene 3 horas para realizar la modificación.</p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-btn color="secondary" @click="home()" class="mr-2">Inicio</v-btn>
                <v-btn color="secondary" @click="changePassword()">Solicitar cambio</v-btn>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>
<script>
//Validaciones
import { validations } from "@/helpers/validations.js";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data: () => ({
    dialog: false,
    loading: false,
    valid: true,
    showPass: false,
    samePasswords: true,
    passwordRules: validations.generalFValidation({
      name: "contraseña",
      required: true,
      minLength: 8
    }),
    user: {
      password: "",
      passwordConfirmation: ""
    }
  }),
  methods: {
    ...mapActions("user", ["updateUser"]),
    ...mapMutations("notifications", ["show"]),
    /**
     * Validar formulario
     */
    async validate() {
      this.loading = true;
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.loading = false;
        delete this.user.passwordConfirmation;
        this.user.token = this.$route.params.token;
        let response = await this.updateUser(this.user);
        if (!response.status) {
          response.message = response.message.replace("GraphQL error: ", "");
          if (response.message === "jwt expired"){
            response.message = "El enlace de recuperación de contraseña ha expirado";
            this.dialog = true;
          }
        } else {
          this.show({ text: "¡Contraseña modificada con éxito!", color: "success" });
          setTimeout(()=>{
            this.login();
          },2000)
        }
      }
      this.loading = false;
    },
    login() {
      this.$router.push("/login");
    },
    home() {
      this.$router.push("/");
    },
    changePassword() {
      this.$router.push("/recuperar-contraseña");
    }
  },
  computed: {
    validatePasswords() {
      return () =>
        this.user.password === this.user.passwordConfirmation ||
        "Las contraseñas deben coincidir";
    }
  }
};
</script>
<style scoped>
.loginContainer {
  min-height: 95vh;
  width: 100vw;
}
.loginWrapper {
  min-height: 90vh;
  width: 100vw;
}
</style>